import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeBetrieblicheDatenZustaendigkeitenProps {
    dummy?: any;
}

export interface DateneingabeBetrieblicheDatenZustaendigkeitenState {
    dummy?: any;
}

export class DateneingabeBetrieblicheDatenZustaendigkeiten extends
    React.Component<DateneingabeBetrieblicheDatenZustaendigkeitenProps, DateneingabeBetrieblicheDatenZustaendigkeitenState> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.onFormChange = this.onFormChange.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    onFormChange(WFormData: any): void {
    }

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_ZUSTAENDIGKEITEN}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onFormChange={this.onFormChange}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ZUSTAENDIGKEITEN)}
                />
            </div>
        );
    }
}
